'use strict';

var authLoginByOtacHelper = require('./authLoginByOtacHelper.js');
var openAuthLoginUrlByOtac = require('./openAuthLoginUrlByOtac.js');
var userManager = require('./userManager/userManager.js');
var webViewUserManager = require('./userManager/webViewUserManager.js');
var iframeUserManager = require('./userManager/iframeUserManager.js');
var consts = require('./consts.js');
var subscriptions = require('./subscriptions.js');
var helpers = require('./helpers.js');



exports.AuthLoginByOtacHelper = authLoginByOtacHelper.AuthLoginByOtacHelper;
exports.openAuthLoginUrlByOtac = openAuthLoginUrlByOtac.openAuthLoginUrlByOtac;
Object.defineProperty(exports, "UserManager", {
	enumerable: true,
	get: function () { return userManager.UserManager; }
});
Object.defineProperty(exports, "WebViewUserManager", {
	enumerable: true,
	get: function () { return webViewUserManager.WebViewUserManager; }
});
Object.defineProperty(exports, "IframeUserManager", {
	enumerable: true,
	get: function () { return iframeUserManager.IframeUserManager; }
});
Object.defineProperty(exports, "ACCESS_DENIED_REASON", {
	enumerable: true,
	get: function () { return consts.ACCESS_DENIED_REASON; }
});
Object.defineProperty(exports, "AUTHENTICATION_UI_TYPE", {
	enumerable: true,
	get: function () { return consts.AUTHENTICATION_UI_TYPE; }
});
exports.AUTH_BROADCAST_CHANNEL_NAME = consts.AUTH_BROADCAST_CHANNEL_NAME;
exports.AUTH_FAILURE_LOGIN_MESSAGE_NAME = consts.AUTH_FAILURE_LOGIN_MESSAGE_NAME;
exports.AUTH_ROUTER_PREFIX_DEFAULT = consts.AUTH_ROUTER_PREFIX_DEFAULT;
exports.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = consts.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME;
Object.defineProperty(exports, "ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS", {
	enumerable: true,
	get: function () { return consts.ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS; }
});
Object.defineProperty(exports, "ESIA_TYPE", {
	enumerable: true,
	get: function () { return consts.ESIA_TYPE; }
});
Object.defineProperty(exports, "LOGIN_TYPE", {
	enumerable: true,
	get: function () { return consts.LOGIN_TYPE; }
});
Object.defineProperty(exports, "LOGOUT_TYPE", {
	enumerable: true,
	get: function () { return consts.LOGOUT_TYPE; }
});
Object.defineProperty(exports, "QUERY", {
	enumerable: true,
	get: function () { return consts.QUERY; }
});
Object.defineProperty(exports, "ROUTES", {
	enumerable: true,
	get: function () { return consts.ROUTES; }
});
exports.subscribeOnLoginFailure = subscriptions.subscribeOnLoginFailure;
exports.subscribeOnLoginSuccess = subscriptions.subscribeOnLoginSuccess;
exports.formatUserData = helpers.formatUserData;
exports.getLoadingUrl = helpers.getLoadingUrl;
exports.getLoginUrl = helpers.getLoginUrl;
exports.getLogoutUrl = helpers.getLogoutUrl;
exports.getSilentSignInUrl = helpers.getSilentSignInUrl;
exports.getSilentSignInVerifyUrl = helpers.getSilentSignInVerifyUrl;
//# sourceMappingURL=index.js.map
